import * as React from 'react';
import './Admin.less';
import { Form, Input, Button, Checkbox, Divider, message, Spin, Row, Col } from 'antd';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import AddSchoolDTO from 'src/models/school/AddSchoolDTO';
import UpdateSchoolDTO from 'src/models/school/UpdateSchoolDTO';
import SchoolApiController from 'src/api/SchoolApiController';
import AddEditSchoolForm from './forms/AddEditSchoolForm';


interface RouteParams {
    id: string;
}

interface AddEditSchoolProps extends PageProps<RouteParams>, LocalizeContextProps { }

interface AddEditSchoolState {
    schoolId: number;
    currentSchool: UpdateSchoolDTO;

    isLoading: boolean;
    isSubmitting: boolean;
}

class AddEditSchool extends React.Component<AddEditSchoolProps, AddEditSchoolState> {
    constructor(props: AddEditSchoolProps) {
        super(props);
        bindAllOfThis(this, AddEditSchool.prototype);

        let schoolId = Number(this.props.match.params.id);
        schoolId = !isNaN(schoolId) ? schoolId : 0;

        this.state = {
            schoolId,
            currentSchool: null,
            isLoading: true,
            isSubmitting: false
        };
    }

    componentDidMount() {
        this.fillForm();
    }

    private fillForm() {
        if (this.state.schoolId > 0) {
            // Edit
            return SchoolApiController.getSchool(this.state.schoolId).then((result) => {
                this.setState({
                    isLoading: false,
                    currentSchool: result.data
                });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditSchool.messageRetrieveError'));
                this.setState({ isLoading: false });
            });
        }
        this.setState({ isLoading: false });
    }

    private handleSubmit(values: UpdateSchoolDTO) {
        this.setState({ isSubmitting: true });

        // Trimming
        values.otherId = values.otherId?.trim();
        values.schoolName = values.schoolName?.trim();
        values.classLinkSourcedId = values.classLinkSourcedId?.trim();

        if (this.state.schoolId < 1) {
            return SchoolApiController.addSchool(values).then(result => {
                message.success(this.props.translate('admin.addEditSchool.messageAdd'));
                this.handleRedirect();
            }).catch(e => {
                message.error(this.props.translate('admin.addEditSchool.messageAddError'));
                this.setState({ isSubmitting: false });
            });
        } else {
            return SchoolApiController.updateSchool(values).then(result => {
                message.success(this.props.translate('admin.addEditSchool.messageUpdate'));
                this.handleRedirect();
            }).catch(e => {
                message.error(this.props.translate('admin.addEditSchool.messageUpdateError'));
                this.setState({ isSubmitting: false });
            });
        }
    }

    private handleRedirect(): void {
        this.props.history.push(Routes.ADMIN_SCHOOLS);
    }

    render() {
        if (this.state.isLoading) {
            return <Spin />;
        }

        return (
            <div>
                <h2>
                    {this.state.schoolId > 0 ? this.state.currentSchool.schoolName : this.props.translate('admin.addEditSchool.addHeader')}
                </h2>

                <Row>
                    <Col xs={24} lg={18} xl={16} xxl={12}>
                        <AddEditSchoolForm
                            schoolData={this.state.currentSchool}
                            isSubmitting={this.state.isSubmitting}
                            onSubmit={this.handleSubmit}
                            onCancel={this.handleRedirect}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withLocalize(AddEditSchool);



// WEBPACK FOOTER //
// ./src/pages/admin/AddEditSchool.tsx